import React, { useState, useEffect } from "react";
import { Modal, ModalBody, Row, Col } from "reactstrap";
import { useDispatch } from "react-redux";
import axiosInstance from "../../../axios-instance";
import UpdateCardModal from "./update-card-modal";
import { SET_IS_LOADING } from "../../../actions/types";

const ConfirmStaffInvitePaymentModal = ({
  isOpen,
  toggle,
  inviteData,
  userPlan,
  onConfirm,
}) => {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [showChangeCardModal, setShowChangeCardModal] = useState(false);
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    if (!isOpen) {
      setData(null);
      setLoadError(null);
      return;
    }

    dispatch({ type: SET_IS_LOADING, payload: true });
    axiosInstance
      .get("/admin/staff-seat-charge-preview")
      .then((res) => {
        if (res.data.success) {
          setData(res.data);
        } else {
          setLoadError(res.data.message || "Unable to load charge preview.");
        }
        dispatch({ type: SET_IS_LOADING, payload: false });
      })
      .catch((err) => {
        const message =
          err?.response?.data?.message ||
          "Unable to load charge preview. Please try again.";
        setLoadError(message);
        dispatch({ type: SET_IS_LOADING, payload: false });
      });
  }, [isOpen]);

  const periodLabel =
    userPlan?.plan_period_type === "monthly" ? "monthly" : "annual";

  return (
    <>
      {showChangeCardModal && (
        <UpdateCardModal toggle={setShowChangeCardModal} />
      )}
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalBody>
          <div className="eventdetailsaddbox rd_modalvieew">
            <div className="box_content rd_modalboxcontent">
              <div className="rd_inputselectheadermodalsetting">
                <button className="rd_colsebtn" onClick={toggle}></button>
              </div>

              <h3 className="rd_modalheadertext rd_modalheadertextleft">
                {data?.is_trialing
                  ? "Add staff member"
                  : "Confirm staff seat payment"}
              </h3>

              {inviteData && (
                <p className="rd_modalheadertextparath mt-3 mb-3">
                  You are inviting{" "}
                  <strong>
                    {inviteData.first_name} {inviteData.last_name}
                  </strong>{" "}
                  ({inviteData.email}).{" "}
                  {data?.is_trialing
                    ? "Adding this staff member will not charge you anything. Billing starts after your free trial ends."
                    : "Payment is charged immediately before the invitation is sent."}
                </p>
              )}

              {loadError && (
                <div className="alert alert-danger" role="alert">
                  {loadError}
                </div>
              )}

              {data && !loadError && (
                <>
                  {data.is_trialing ? (
                    <p className="rd_modalheadertextparath mt-3 mb-3">
                      You will not be charged today for this staff seat. After
                      your trial ends on{" "}
                      <span style={{ color: "#FE9920", fontWeight: "700" }}>
                        {data.next_billing_date}
                      </span>
                      , it will be included with your subscription.
                    </p>
                  ) : (
                    <>
                      <p className="rd_modalheadertextparath mt-3 mb-3">
                        Plan price:{" "}
                        <span style={{ color: "#FE9920", fontWeight: "700" }}>
                          ${data.seat_price}
                        </span>{" "}
                        per user / {periodLabel === "monthly" ? "month" : "year"}.
                        You will be charged{" "}
                        <span style={{ color: "#FE9920", fontWeight: "700" }}>
                          ${data.charge_today}
                        </span>{" "}
                        <strong>today</strong> —{" "}
                        <span style={{ color: "#FE9920", fontWeight: "700" }}>
                          ${data.seat_price}
                        </span>{" "}
                        ×{" "}
                        <span style={{ color: "#FE9920", fontWeight: "700" }}>
                          {data.days_remaining_in_period}
                        </span>
                        /{data.days_in_period} days left in this billing cycle.
                      </p>

                      <p className="rd_modalheadertextparath mt-3 mb-3">
                        Charged to your{" "}
                        <span style={{ color: "#FE9920", fontWeight: "700" }}>
                          {data.card_brand}
                        </span>{" "}
                        ending with{" "}
                        <span style={{ color: "#FE9920", fontWeight: "700" }}>
                          {data.card_last_four}
                        </span>
                        . Starting{" "}
                        <span style={{ color: "#FE9920", fontWeight: "700" }}>
                          {data.next_billing_date}
                        </span>
                        , your recurring {periodLabel} bill will be{" "}
                        <span style={{ color: "#FE9920", fontWeight: "700" }}>
                          ${data.recurring_bill_amount}
                        </span>{" "}
                        for{" "}
                        <span style={{ color: "#FE9920", fontWeight: "700" }}>
                          {data.new_seats}
                        </span>{" "}
                        paid seats.
                      </p>
                    </>
                  )}

                  {!data.is_trialing && (
                    <Row className="mb-3">
                      <Col className="text-center">
                        <button
                          className="btn btn_success btn-sm"
                          onClick={() => setShowChangeCardModal(true)}
                        >
                          Change Card
                        </button>
                      </Col>
                    </Row>
                  )}
                </>
              )}

              <div className="rd_cancelappbtnmodal">
                <button className="btn btn-danger" onClick={toggle}>
                  Cancel
                </button>
                <button
                  className="btn btn-app"
                  disabled={!data || !!loadError}
                  onClick={() => {
                    onConfirm(inviteData);
                    toggle();
                  }}
                >
                  {data?.is_trialing ? "Send Invitation" : "Pay & Send Invitation"}
                </button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ConfirmStaffInvitePaymentModal;
